var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.5 1.70215V4.80005C8.5 5.22009 8.5 5.43011 8.58175 5.59055C8.65365 5.73167 8.76839 5.8464 8.90951 5.91831C9.06994 6.00005 9.27996 6.00005 9.7 6.00005H12.7979M4 11.25V13.5M10 9.75V13.5M7 7.875V13.5M13 7.49117V12.9C13 14.1601 13 14.7902 12.7548 15.2715C12.5391 15.6948 12.1948 16.039 11.7715 16.2548C11.2902 16.5 10.6601 16.5 9.4 16.5H4.6C3.33988 16.5 2.70982 16.5 2.22852 16.2548C1.80516 16.039 1.46095 15.6948 1.24524 15.2715C1 14.7902 1 14.1601 1 12.9V5.1C1 3.83988 1 3.20982 1.24524 2.72852C1.46095 2.30516 1.80516 1.96095 2.22852 1.74524C2.70982 1.5 3.33988 1.5 4.6 1.5H7.00883C7.55916 1.5 7.83432 1.5 8.09327 1.56217C8.32285 1.61729 8.54233 1.7082 8.74364 1.83156C8.9707 1.9707 9.16528 2.16527 9.55442 2.55442L11.9456 4.94558C12.3347 5.33473 12.5293 5.5293 12.6684 5.75636C12.7918 5.95767 12.8827 6.17715 12.9378 6.40673C13 6.66568 13 6.94084 13 7.49117Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTran);
export default __webpack_public_path__ + "static/media/tran.4c9ab69387105d7e2bcff3a179e92ae2.svg";
export { ForwardRef as ReactComponent };